import { computed } from '@vue/composition-api';

import { priceFormatted } from '@/utils/formatters/formattedPrice';
import { checkMobile } from '@/utils/deviceCheck';

const useCheapestDeliveries = (props) => {
  const isMobile = checkMobile();

  const DELIVERY_NAMES = {
    courier: 'Курьерская доставка',
    post: 'Почта России',
    pvz: 'Пункты выдачи партнеров',
    pvzBook24: 'Пункты выдачи Book24',
    pvzChitaiGorod: 'Доставка в магазины «Читай-город»',
    pvzGogolMogol: 'Доставка в магазины «Гоголь-Моголь»',
    pvzBookvoed: 'Доставка в магазины «Буквоед»',
  };

  const formattedItem = item => ({
    name: DELIVERY_NAMES[item.type],
    price: priceFormatted(+item.price, { beforeText: +item.price ? 'от' : '', setFreeText: !isMobile }),
  });

  const list = computed(() => props.cheapestDeliveries.map(item => formattedItem(item)));

  const minPrice = computed(() => {
    const [minItem] = [...props.cheapestDeliveries].sort((a, b) => {
      if (+a.price > +b.price) {
        return 1;
      }
      if (+a.price < +b.price) {
        return -1;
      }
      return 0;
    });

    return minItem?.price ? Number(minItem.price) : null;
  });

  const minPriceFormatted = computed(() => (minPrice.value !== null ? priceFormatted(minPrice.value, { beforeText: 'от ' }) : null));

  return {
    list,
    minPrice,
    minPriceFormatted,
  };
};

export default useCheapestDeliveries;
